/**
 * @fileoverview This file contains the top contents of the website.
 */

import { TableRow } from "../components/TableRow";
import { ContactLink } from "../components/ContactLink";
import LinkList from "../components/LinkList";
import { useTranslation } from "react-i18next";

/**
 * Top contents
 * @returns {JSX.Element} トップページの JSX element
 */
export function TopContents(): JSX.Element {
  const { t } = useTranslation();

  //トラブルシューティングページへのリンクリスト
  const items = [
    { to: "/anasys/HelpAndSupport", text: t("トラブルシューティングとQandA") },
  ];

  /**
   * お知らせのリンクリスト
   */
  const noticeList = [
    {
      to: "/anasys/Version#Ve603000",
      text: t("Ver6.03.000リリース(2025/03/12)"),
    },
    {
      to: "/anasys/Version#DriverUpdate",
      text: t("デバイスドライバーバージョンアップ"),
    },
    {
      to: "/anasys/HelpAndSupport#UsbComMode",
      text: t("USB通信モードが解除されない場合の対処"),
    },
    {
      to: "/anasys/Ghs8atCoverSetting",
      text: t("外ケース取り付け時の注意点"),
    },
  ];
  /**
   * ダウンロードの項目のリンクリスト
   */
  const downloadLinkList = [
    {
      to: "/anasys/Download",
      text: t("ダウンロードページへ"),
    },
    {
      to: "/anasys/HowToDownLoadAndInstall",
      text: t("ダウンロードとインストールの手順"),
    },
    {
      to: "/anasys/Version",
      text: t("バージョンアップ内容説明"),
    },
    {
      to: "/anasys/HowToDownloadDeviceDriver",
      text: t("デバイスドライバーのダウンロード方法"),
    },
    {
      to: "/anasys/HowToInstallDeviceDriver",
      text: t("デバイスドライバーのインストール方法"),
    },
  ];

  return (
    <div>
      <div className="c-section">
        <p className="c-text">
          {t(
            "アナシス・ソフトウェアは、拡散式硫化水素測定器（型式:GHS-8AT,GHS-8AT-EX）のために開発されたソフトウェアです。"
          )}
          {t(
            "測定器で収集された測定データ（ロギングデータ）をパソコンに取り込み、そのロギングデータから測定場所における環境状態を調べることができます。"
          )}
        </p>
      </div>

      <section className="c-section">
        <h2 className="p-heading-2">{t("お知らせ")}</h2>
        <LinkList items={noticeList} />
      </section>

      <section className="c-section">
        <h2 className="p-heading-2">
          {t("ダウンロード Ver6.03.000(Release 2025.03.12) 4,554kB")}
        </h2>
        <p className="c-text">
          {t(
            "最新版のアナシスソフトウェア,GHS-8AT用デバイスドライバーをダウンロードできます。"
          )}
          {t(
            "[ダウンロードページへ]のリンクからダウンロードページにアクセスしてください。"
          )}
        </p>
        {/** 上マージン制御用のユーティリティ .u-mt-xx を使用。common.css の288行目から314行目を参照*/}
        <LinkList items={downloadLinkList} />
      </section>

      <section className="c-section">
        <h2 className="p-heading-2">{t("ソフトウェアのトラブルや疑問")}</h2>
        <p className="c-text">
          {t(
            "ソフトウェアの使い方やインストール時のエラーなど困ったときにはトラブルシューティングとQandAのページで対処方法を検索してください。"
          )}
        </p>
        <LinkList items={items} />
      </section>

      <section className="c-section">
        <h2 className="p-heading-2">{t("特長")}</h2>
        <ul className="c-square">
          <li>{t("硫化水素測定器で記録したデータを簡単にグラフ化")}</li>
          <li>{t("硫化水素濃度及び温度を同一グラフ上に表示")}</li>
          <li>
            {t("GHS-8ATとデータ通信,条件設定が可能,データを同一グラフ上に表示")}
          </li>
          <li>{t("同時表示できるグラフの本数最大10本")}</li>
          <li>{t("上下グラフ表示機能により時系列の異なるグラフを表示")}</li>
          <li>
            {t(
              "任意の基準濃度線を表示し解析機能により基準濃度を超えたカウント数を表示"
            )}
          </li>
          <li>{t("Windows 10, 11で動作")}</li>
        </ul>
      </section>

      <section className="c-section">
        <h2 className="p-heading-2">{t("仕様")}</h2>
        <table className="c-table" id="specTable">
          <tbody>
            <TableRow
              label={t("名称")}
              value={t("拡散式硫化水素測定機専用ソフト アナシス・ソフトウェア")}
            />
            <TableRow label={t("型式")} value="GHS-PC-3" />
            <TableRow label={t("動作OS")} value="Windows 10, 11" />
            <TableRow
              label={t("必要なソフトウェア")}
              value={t(".NET Framework 4.7以降")}
            />
            <TableRow label={t("インターフェース")} value="USB2.0" />
            <TableRow
              label={t("主な機能")}
              value={t(
                "ロギングデータ読出し，ロギング条件設定，時計設定，ロギングデータ保存，グラフデータ保存，複数グラフ表示(最大10グラフ), データCSV変換"
              )}
            />
          </tbody>
        </table>
      </section>
      <ContactLink />
    </div>
  );
}
